import React from 'react';
import InactiveIcon from '@components-clean/core/icons/inactive-icon/inactive-icon';
import InformationIcon from '@components-clean/core/icons/information-icon';
import ValidationIconSuffix from '@components-clean/core/icons/validation-icon-suffix';

const IconsPage = () => {
    return (
        <div>
            <div>
                <h3>Information Icon</h3>
                <InformationIcon
                    dataTestId="info-icon"
                    title="Lorem ipsum dolor sit amet, consectetur adipiscing elit."
                />
            </div>
            <div>
                <h3>Inactive Icon</h3>
                <InactiveIcon dataTestId="inactive-icon" tooltipPosition="top" />
            </div>
            <div>
                <h3>Validation Icon</h3>
                <ValidationIconSuffix />
            </div>
        </div>
    );
};

export default IconsPage;
